<template>
  <div>
    <div
      class="lg:grid lg:place-items-start lg:justify-items-center lg:grid-cols-2 px-4 lg:px-20 lg:pt-20 pt-8 gap-2 lg:gap-9"
    >
      <div class="lg:text-center xl:text-start">
        <h1
          class="text-cerise-red-600 mb-4 font-extrabold text-2xl leading-6 lg:text-4xl tracking-normal lg:leading-9 mt-5"
        >
          È facile, gratuito e i tuoi buoni si cumulano con le promozioni in
          corso
        </h1>
        <div class="text-[#5C5C5C] text-xl lg:text-3xl">
          <h2>
            <span class="font-bold text-cerise-red-600"> Più</span> punti
            accumuli,
          </h2>
          <h2>
            <span class="font-bold text-cerise-red-600">Più </span> risparmi,
          </h2>
          <h2>
            <span class="font-bold text-cerise-red-600">Più </span> benefici
            arrivano.
          </h2>
        </div>

        <p class="mt-5">
          Prénatal è sempre vicina a te. Ti basta accumulare punti per
          accedere a promozioni e buoni sconto su tutto l’abbigliamento, con
          tanti servizi esclusivi.
        </p>

        <nuxt-img
          src="images/prenatal-lover-hp.png"
          alt="prenatal-card"
          format="webp"
          class="mt-16 hidden lg:block"
        />
        <nuxt-img
          src="images/prenatal-lover-hp-mobile.png"
          alt="prenatal-card"
          format="webp"
          class="mt-4 mx-auto block w-2/3 lg:hidden"
        />
      </div>
      <div class="w-full flex flex-col">
        <div class="rounded-t-base border shadow-lg py-10 px-4 md::p-10">
          <h1
            class="text-cerise-red-600 text-xl lg:text-3xl font-extrabold text-center"
          >
            Come funziona?
          </h1>

          <div class="space-y-5 my-7 text-sm lg:text-base">
            <div class="flex items-center gap-5">
              <div
                class="bg-cerise-red-600 size-12 md:size-16 lg:size-24 rounded-full shrink-0 flex justify-center items-center"
              >
                <nuxt-img src="images/services/prenatal.svg" class="w-1/2" />
              </div>
              <div>
                Aumenta il valore dello shopping! Si
                <strong>accumulano punti</strong> per ogni spesa in negozio e
                online
              </div>
            </div>
            <div class="flex items-center gap-5">
              <div
                class="bg-cerise-red-600 size-12 md:size-16 lg:size-24 rounded-full shrink-0 flex justify-center items-center"
              >
                <nuxt-img src="images/services/coupon.svg" class="w-1/2" />
              </div>
              <div>
                <strong>Ogni 200 punti</strong> ottieni
                <strong>
                un buono sconto del {{ discount }}% su tutto l’abbigliamento
                </strong>
                da utilizzare in negozio e online,
                 <strong>cumulabile con altre promozioni.</strong>
              </div>

            </div>
            <div class="flex items-center gap-5">
              <div
                class="bg-cerise-red-600 size-12 md:size-16 lg:size-24 rounded-full shrink-0 flex justify-center items-center"
              >
                <nuxt-img
                  src="images/services/vantaggi-dei-partners.svg"
                  class="w-1/2"
                />
              </div>
              <div>
                Al raggiungimento dei primi 200 punti diventi<strong>
                  Prénatal Lover Gold</strong
                >
                e potrai accedere a <strong> servizi premium aggiuntivi</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-cerise-red-600 p-9 text-white rounded-b-base">
          <h1 class="text-base lg:text-xl font-extrabold mb-5">
            Come posso accumulare i punti Lover?
          </h1>
          <div class="space-y-4 text-sm lg:text-base">
            <p>
              I punti Lover ti permettono di sbloccare promozioni, sconti e
              servizi esclusivi.
            </p>

            <ul>
              <li>Vediamo come:</li>
              <li>• 1 punto Lover ogni 1€ di spesa su tutto l’assortimento.</li>
            </ul>

            <p>
              Ogni 200 punti ottieni un buono sconto unico del {{ discount }}%
              valido su tutto l’abbigliamento in negozio e online senza un
              minimo di spesa. Il buono è cumulabile con le altre promozioni ed
              è valido una tantum sul tuo prossimo acquisto.
            </p>
          </div>
          <nuxt-link to="/regolamento-programma-fedelta">
            <CorePrimaryButton class="mt-4 !border-white">
              LEGGI IL REGOLAMENTO
            </CorePrimaryButton>
          </nuxt-link>

          <h2 class="mt-4 text-sm lg:text-base">
            Il programma scade il 28/02/2027.
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { fetchOptions } from '~/composables/options'

const options = await fetchOptions()
const discount = options.discount


</script>
